module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets//blue_1.png?v=9b151ece";